import React from 'react'
import { Formik, Form, Field, FormikHelpers } from 'formik'
import * as yup from 'yup'
import { Button, InputField } from 'components'
import { useTranslation } from 'react-i18next'

interface LoginFormValues {
  username: string
  password: string
}

const initialValues: LoginFormValues = {
  username: '',
  password: '',
}

const validationSchema = yup.object({
  username: yup
    .string()
    .email('pages.login.global.email.invalid')
    .required('pages.login.global.email.required'),
  password: yup.string().required('pages.login.global.password.required'),
})

interface LoginFormProps {
  onSubmit: (values: any, formikHelpers: FormikHelpers<LoginFormValues>) => void
}

export const LoginForm: React.FunctionComponent<LoginFormProps> = ({
  onSubmit,
}) => {
  const { t } = useTranslation()
  const isReadOnly = window.REACT_APP_LOGIN_READONLY === true
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
    >
      <Form>
        <Field
          component={InputField}
          id="username"
          name="username"
          type="text"
          label={t('global.emailAddress')}
          readOnly={isReadOnly}
        />

        <Field
          component={InputField}
          id="password"
          name="password"
          type="password"
          label={t('global.password')}
          readOnly={isReadOnly}
        />

        <Button id="login-button-e2e" type="submit" aria-label="Submit">
          {t('global.login')}
        </Button>
      </Form>
    </Formik>
  )
}
